import { post } from '../util/request';

const ANSWERS_API = '/a/api/answers';

async function getAnswers(payload) {
  return post(ANSWERS_API)(payload).then(res => res.body?.payload);
}

export { getAnswers };
